import {Component, OnInit} from '@angular/core';
import {NewPasswordModel} from "../../models/user/users.model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CustomValidators} from "ng2-validation";
import {UsersService} from "../users/users.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.less']
})
export class ConfirmPasswordComponent implements OnInit {
  data = new NewPasswordModel();
  valForm: FormGroup;
  patternPassword = /^\S*$/;
  hash: any;
  password: string;
  confirmpassword: string;

  constructor(private fb: FormBuilder, private usersService: UsersService, private router: Router) {
    this.valForm = this.fb.group({
      'newpassword': [null, Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(4), Validators.maxLength(255), Validators.pattern(this.patternPassword)])],
      'confirmpassword': [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.hash = this.router.routerState.snapshot.url.split('/')[2];
    this.data.confirmHash = this.hash;
  }

  submit() {
    this.usersService.setNewPassword(this.data)
      .subscribe((response) => {
          this.router.navigate(['/login']);
        },
        (error) => {
          // console.log(error);
        })
  }

  redirectToLogin() {
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/confirm-password/confirm-password.component.ts